export default __webpack_public_path__ + "static/media/media-auto-2.290b5a9c.jpg";